import React, { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import "./FanCoil.css";
import CircleSlider from "./Sliders/CircleSlider";
import { DeleteEquipments, UpdateEquipments } from "../../api/api";
import { Link, useNavigate, useParams } from "react-router-dom";
import ErrorToast from "../toasts/ErrorToast";
import { MqttContext } from "../../context/MQTTContext";
import SuccessToast from "../toasts/SuccessToast";
import WarningAlert from "../sweeAlerts/WarningAlert";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const FanCoil = () => {
  const {
    update,
    authUser,
    equipmentButtons,
    devices,
    equipments,
    setEquipments,
    handleEquipmentsListModal,
    setSelectedEquipment,
    handleChangeNameModal,
    refreshMqtt,
    setChangeNameOptions,
    currentRoom,
    selectedEquipment,
  } = useContext(Context);
  const { clients } = useContext(MqttContext);

  const [buttons, setButtons] = useState([]);
  const [sliderValue, setSliderValue] = useState([{ value: 10 }]);
  const [fanSpeed, setFanSpeed] = useState(null);
  const [fanMode, setFanMode] = useState(null);
  const [fanState, setFanState] = useState(false);
  const [fanStatus, setFanStatus] = useState(2);
  const [channelTemp, setChannelTemp] = useState(null);
  const [outTemp, setOutTemp] = useState(null);
  const [humidity, setHumidity] = useState(null);
  const [ColoredButton, setColoredButton] = useState(null);
  const [shouldPublishMessage, setShouldPublishMessage] = useState(false);
  const [editEquipmentName, setEditEquipmentName] = useState(false);
  const [editedEquipmentName, setEditedEquipmentName] = useState("");

  const navigate = useNavigate();

  const { equipment_id: eq_id, room_id, equipment_type: eq_type } = useParams();

  useEffect(() => {
    let btns = equipmentButtons
      .filter((eq_btn) => eq_btn.equipment_id == eq_id)
      .map((btn) => ({
        ...btn,
        digit: Number(btn.digit),
      }));

    setButtons(btns);
    setSelectedEquipment({
      id: eq_id,
      type: eq_type,
    });
    if (btns.length) {
      let clientsId = [];
      btns.forEach((button) => {
        let device = devices.find((d) => d.id == button.device_id);
        if (!device) {
          return;
        }
        if (
          device.is_bus == 1 &&
          clients[device?.bridge_device?.id] &&
          !clientsId.includes(device.id)
        ) {
          const messageListener = (topic, message) => {
            const endOfTwoCharToken =
              String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
            const deviceSerial =
              String.fromCharCode(message[3]) +
              String.fromCharCode(message[4]) +
              String.fromCharCode(message[5]) +
              String.fromCharCode(message[6]) +
              String.fromCharCode(message[7]) +
              String.fromCharCode(message[8]);
            if (
              device.bridge_device.internet_token.slice(-2) ===
                endOfTwoCharToken &&
              device.serial === deviceSerial &&
              (message[10] == 1 || message[10] == 3) &&
              message[2] == 14
            ) {
              if (message.length == 36) {
                if (
                  message[12] !== 2 &&
                  message[12] !== 3 &&
                  message[12] !== 4 &&
                  message[12] !== 5
                ) {
                  ErrorToast("تنظیمات مد کاری دستگاه بررسی شود");
                  return 0;
                }
                setOutTemp(
                  message[11] <= 127
                    ? message[11] / 2
                    : (message[11] - 256) / 2,
                );
                let chTemp;
                if (button.digit == 0) {
                  chTemp =
                    message[26] * 256 + message[27] <= 32767
                      ? (message[26] * 256 + message[27]) / 10
                      : (message[26] * 256 + message[27] - 65536) / 10;
                } else if (button.digit == 1) {
                  chTemp =
                    message[28] * 256 + message[29] <= 32767
                      ? (message[28] * 256 + message[29]) / 10
                      : (message[28] * 256 + message[29] - 65536) / 10;
                }
                setChannelTemp(chTemp);

                setHumidity(message[21] == 255 ? "-" : message[21]);
                setColoredButton(null);
                if (button.digit == 0) {
                  let binaryMode = message[13].toString(2).padStart(16, "0");
                  setFanStatus(message[12]);
                  if (message[13] == 0) {
                    setFanState(false);
                  } else {
                    binaryMode = binaryMode.split("").reverse();
                    setFanSpeed(
                      parseInt(`${binaryMode[1]}${binaryMode[0]}`, 2),
                    );
                    setFanMode(parseInt(`${binaryMode[3]}${binaryMode[2]}`, 2));
                    setSliderValue([{ value: message[14] / 2 }]);
                    setFanState(binaryMode[4] == 0 ? false : true);
                  }
                } else if (button.digit == 1) {
                  let binaryMode = message[18].toString(2).padStart(16, "0");
                  binaryMode = binaryMode.split("").reverse();
                  setFanStatus(message[17]);
                  setFanSpeed(parseInt(`${binaryMode[1]}${binaryMode[0]}`, 2));
                  setFanMode(parseInt(`${binaryMode[3]}${binaryMode[2]}`, 2));
                  setSliderValue([{ value: message[19] / 2 }]);
                  setFanState(binaryMode[4] == 0 ? false : true);
                }
              }
            }
          };

          // clients[button.device.bridge_device.id].removeAllListeners("message");
          clients[device.bridge_device.id].on("message", messageListener);

          let buffer = new ArrayBuffer(10);
          let asciiCode = new Uint8Array(buffer);
          asciiCode[0] = 14;
          asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
          asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
          asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
          asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
          asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
          asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
          asciiCode[7] = device.type + 50;
          asciiCode[8] = 3;
          asciiCode[9] = 0;
          let message = device.bridge_device.internet_token;

          let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
          clients[device.bridge_device.id].publish(
            device.bridge_device.serial + "/sys",
            combinedMessage,
          );
          clientsId = [...clientsId, device.id];
          setColoredButton(btns[0].id);
        } else if (
          device.id &&
          device.username &&
          device.password &&
          clients[device.id] &&
          !clientsId.includes(device.id)
        ) {
          const messageListener = (topic, message) => {
            const endOfTwoCharToken =
              String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
            if (
              device.internet_token.slice(-2) === endOfTwoCharToken &&
              (message[2] == 3 || message[2] == 1)
            ) {
              if (message.length == 28) {
                if (
                  message[4] !== 2 &&
                  message[4] !== 3 &&
                  message[4] !== 4 &&
                  message[4] !== 5
                ) {
                  ErrorToast("تنظیمات مد کاری دستگاه بررسی شود");
                  return 0;
                }
                setOutTemp(
                  message[3] <= 127 ? message[3] / 2 : (message[3] - 256) / 2,
                );
                let chTemp;
                if (button.digit == 0) {
                  chTemp =
                    message[18] * 256 + message[19] <= 32767
                      ? (message[18] * 256 + message[19]) / 10
                      : (message[18] * 256 + message[19] - 65536) / 10;
                } else if (button.digit == 1) {
                  chTemp =
                    message[20] * 256 + message[21] <= 32767
                      ? (message[20] * 256 + message[21]) / 10
                      : (message[20] * 256 + message[21] - 65536) / 10;
                }
                setChannelTemp(chTemp);

                setHumidity(message[13] == 255 ? "-" : message[13]);
                setColoredButton(null);
                if (button.digit == 0) {
                  let binaryMode = message[5].toString(2).padStart(16, "0");
                  setFanStatus(message[4]);
                  if (message[5] == 0) {
                    setFanState(false);
                  } else {
                    binaryMode = binaryMode.split("").reverse();
                    setFanSpeed(
                      parseInt(`${binaryMode[1]}${binaryMode[0]}`, 2),
                    );
                    setFanMode(parseInt(`${binaryMode[3]}${binaryMode[2]}`, 2));
                    setSliderValue([{ value: message[6] / 2 }]);
                    setFanState(binaryMode[4] == 0 ? false : true);
                  }
                } else if (button.digit == 1) {
                  let binaryMode = message[10].toString(2).padStart(16, "0");
                  binaryMode = binaryMode.split("").reverse();
                  setFanStatus(message[9]);
                  setFanSpeed(parseInt(`${binaryMode[1]}${binaryMode[0]}`, 2));
                  setFanMode(parseInt(`${binaryMode[3]}${binaryMode[2]}`, 2));
                  setSliderValue([{ value: message[11] / 2 }]);
                  setFanState(binaryMode[4] == 0 ? false : true);
                }
              }
            }
          };

          clients[device.id].on("message", messageListener);

          let buffer = new ArrayBuffer(2);
          let asciiCode = new Uint8Array(buffer);
          asciiCode[0] = 3;
          asciiCode[1] = 0;
          let message = device.internet_token;

          // ترکیب رشته و بافر
          let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
          clients[device.id].publish(device.serial + "/sys", combinedMessage);
          setColoredButton(button.id);
          clientsId = [...clientsId, device.id];
        }
      });
      return () => {
        console.log("btns are", btns);
        btns.forEach((button) => {
          let device = devices.find((d) => d.id == button.device_id);
          if (!device) {
            return;
          }
          if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
            clients[device.bridge_device.id].removeAllListeners("message");
          } else if (
            device.id &&
            device.username &&
            device.password &&
            clients[device.id]
          ) {
            clients[device.id].removeAllListeners("message");
          }
        });
      };
    }
  }, [update, equipmentButtons, refreshMqtt, eq_id]);

  useEffect(() => {
    if (buttons.length && fanMode != null && fanSpeed != null) {
      let device = devices.find((d) => d.id == buttons[0].device_id);
      if (!device) {
        return;
      }
      if (device.is_bus == 1) {
        let buffer = new ArrayBuffer(13);
        let asciiCode = new Uint8Array(buffer);
        let mode =
          (fanState ? "1" : "0") +
          fanMode.toString(2).padStart(2, "0") +
          fanSpeed.toString(2).padStart(2, "0");

        mode = mode.padStart(8, "0");
        asciiCode[0] = 14;
        asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
        asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
        asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
        asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
        asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
        asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
        asciiCode[7] = device.type + 50;
        asciiCode[8] = 1;
        asciiCode[9] = buttons[0].digit + 6;
        asciiCode[10] = parseInt(mode, 2);
        asciiCode[11] = sliderValue[0].value * 2;
        asciiCode[12] = 0;

        let message = device.bridge_device.internet_token;

        // ترکیب رشته و بافر
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

        clients[device.bridge_device.id].publish(
          device.bridge_device.serial + "/sys",
          combinedMessage,
        );
        setColoredButton(buttons[0].id);
      } else {
        let buffer = new ArrayBuffer(5);
        let asciiCode = new Uint8Array(buffer);
        let mode =
          (fanState ? "1" : "0") +
          fanMode.toString(2).padStart(2, "0") +
          fanSpeed.toString(2).padStart(2, "0");

        mode = mode.padStart(8, "0");
        asciiCode[0] = 1;
        asciiCode[1] = buttons[0].digit + 6;
        asciiCode[2] = parseInt(mode, 2);
        asciiCode[3] = sliderValue[0].value * 2;
        asciiCode[4] = 0;

        let message = device.internet_token;

        // ترکیب رشته و بافر
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

        clients[device.id].publish(device.serial + "/sys", combinedMessage);
        setColoredButton(buttons[0].id);
      }
    }
  }, [shouldPublishMessage]);

  const handleChangeFanSpeed = (speed) => {
    if (fanState) {
      setFanSpeed(speed);
      setShouldPublishMessage(!shouldPublishMessage);
    }
  };

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str); // تبدیل رشته به بایت‌ها

    // ساخت یک بافر جدید که به اندازه رشته و بافر اصلی است
    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);

    // قرار دادن رشته در ابتدا
    newBuffer.set(encodedString, 0);

    // قرار دادن بافر در ادامه
    newBuffer.set(new Uint8Array(buffer), encodedString.length);

    return newBuffer;
  };

  const handleChangeFanMode = (mode) => {
    if (fanState) {
      setFanMode(mode);
      setShouldPublishMessage(!shouldPublishMessage);
    }
  };

  const handleChangeFanState = (state) => {
    setFanState(state);
    setShouldPublishMessage(!shouldPublishMessage);
  };

  const handleChangeEquipmentName = (equipment_id) => {
    const onSubmitFunc = ({ equipment_id, name }) => {
      UpdateEquipments({
        equipment_id,
        name,
      }).then((res) => {
        const updatedEquipments = equipments.map((item) =>
          item.id === equipment_id
            ? {
                ...item,
                equipment: { ...item.equipment, name: name },
              }
            : item,
        );
        setEquipments(updatedEquipments);
      });
    };
    const newOptions = {
      name:
        equipments.find((eq) => eq.id == equipment_id)?.equipment.name ?? "",
      onSubmit: (newName) => {
        onSubmitFunc({ equipment_id, name: newName });
      },
    };
    setChangeNameOptions(newOptions);
    handleChangeNameModal();
  };

  const handleRemoveEquipment = (equipment_id) => {
    WarningAlert(
      "آیا از حذف این تجهیز اطمینان دارید؟",
      "",
      "تایید",
      "انصراف",
    ).then(function (result) {
      if (result.value) {
        DeleteEquipments({ equipment_id }).then((res) => {
          SuccessToast(res.data.message);
          let newEquipments = equipments.filter((eq) => eq.id != equipment_id);
          setEquipments(newEquipments);
          let lstEquipment = newEquipments.find(
            (eq) => eq.room_id == currentRoom,
          );
          handleEquipment(lstEquipment, currentRoom);
        });
      }
    });
  };

  const handleEquipment = (equipment, roomId) => {
    if (!equipment) return navigate("/room/" + roomId);
    equipment = equipment.equipment;
    setSelectedEquipment({
      id: equipment.id,
      type: equipment.type,
    });
    if (!equipment) {
      return navigate("/");
    } else if (equipment.type == 1) {
      return navigate(
        "/room/key/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 3) {
      return navigate(
        "/room/remote/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 4) {
      return navigate(
        "/room/dimmer/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 5) {
      return navigate(
        "/room/thermostat/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 9) {
      return navigate(
        "/room/rgb/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 99) {
      return navigate(
        "/room/wireless-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 100) {
      return navigate(
        "/room/television/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 501) {
      return navigate(
        "/room/fan-coil/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 401) {
      return navigate(
        "/room/scenario-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 503) {
      return navigate(
        "/room/humidity/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 502) {
      return navigate(
        "/room/motor/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9998) {
      return navigate(
        "/room/input/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9999) {
      return navigate(
        "/room/input-status/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 600) {
      return navigate(
        "/room/data-logger/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    }
  };

  const renderButtons = () => {
    return buttons.map((button) => {
      let device = devices.find((d) => d.id == button.device_id);
      if (!device) {
        return;
      }
      return (
        <div
          className="row fan-coil-box rounded-3 px-1"
          key={button.id}
          style={{
            boxShadow:
              ColoredButton != button.id
                ? ""
                : "0 0.25rem 1rem rgba(0, 122, 255, 0.45)",
          }}
        >
          <div className="col-12">
            <p
              className="text-end text-secondary m-0"
              style={{ lineHeight: "1", fontSize: "11px" }}
            >
              C{button.name}-S/{device.serial}
            </p>
          </div>
          <div className="col-12 text-center slider-power">
            <CircleSlider
              value={sliderValue}
              setValue={setSliderValue}
              isDisable={!fanState}
              setShouldPublishMessage={setShouldPublishMessage}
              shouldPublishMessage={shouldPublishMessage}
            />
            <div
              className="power-key"
              onClick={() => handleChangeFanState(!fanState)}
            >
              <img
                src="/assets/img/app-icons/Li1.png"
                style={{ width: "4rem" }}
                alt=""
              />
            </div>
          </div>
          <div className="d-flex justify-content-around align-items-center options">
            <div onClick={() => handleChangeFanSpeed(3)}>
              <img
                src={
                  fanSpeed == 3 && fanState
                    ? "/assets/img/app-icons/IY.png"
                    : "/assets/img/app-icons/IY-1.png"
                }
                style={{ width: "100%", maxWidth: "2.5rem" }}
                alt=""
              />
            </div>
            <div onClick={() => handleChangeFanSpeed(2)}>
              <img
                src={
                  fanSpeed == 2 && fanState
                    ? "/assets/img/app-icons/0P.png"
                    : "/assets/img/app-icons/0P-1.png"
                }
                style={{ width: "100%", maxWidth: "2.5rem" }}
                alt=""
              />
            </div>
            <div onClick={() => handleChangeFanSpeed(1)}>
              <img
                src={
                  fanSpeed == 1 && fanState
                    ? "/assets/img/app-icons/0P1.png"
                    : "/assets/img/app-icons/0P1-1.png"
                }
                style={{ width: "100%", maxWidth: "2.5rem" }}
                alt=""
              />
            </div>
            <div onClick={() => handleChangeFanSpeed(0)}>
              <img
                src={
                  fanSpeed == 0 && fanState
                    ? "/assets/img/app-icons/0P2.png"
                    : "/assets/img/app-icons/0P2-1.png"
                }
                style={{ width: "100%", maxWidth: "2.5rem" }}
                alt=""
              />
            </div>
          </div>
          <div className="d-flex justify-content-around align-items-center options">
            <div onClick={() => handleChangeFanMode(3)}>
              <img
                src={
                  fanMode == 3 && fanState
                    ? "/assets/img/app-icons/Eg.png"
                    : "/assets/img/app-icons/Eg-1.png"
                }
                style={{ width: "100%", maxWidth: "2.5rem" }}
                alt=""
              />
            </div>
            <div onClick={() => handleChangeFanMode(1)}>
              <img
                src={
                  fanMode == 1 && fanState
                    ? "/assets/img/app-icons/ex.png"
                    : "/assets/img/app-icons/ex-1.png"
                }
                style={{ width: "100%", maxWidth: "2.5rem" }}
                alt=""
              />
            </div>
            <div onClick={() => handleChangeFanMode(0)}>
              <img
                src={
                  fanMode == 0 && fanState
                    ? "/assets/img/app-icons/J4.png"
                    : "/assets/img/app-icons/J4-1.png"
                }
                style={{ width: "100%", maxWidth: "2.5rem" }}
                alt=""
              />
            </div>
            <div onClick={() => handleChangeFanMode(2)}>
              <img
                src={
                  fanMode == 2 && fanState
                    ? "/assets/img/app-icons/5Q1.png"
                    : "/assets/img/app-icons/5Q1-1.png"
                }
                style={{ width: "100%", maxWidth: "2.5rem" }}
                alt=""
              />
            </div>
          </div>
          <div className="status d-flex justify-content-around flex-nowrap">
            <div className="speed">
              <img
                src={
                  fanStatus == 3
                    ? "/assets/img/app-icons/Wl.png"
                    : fanStatus == 4
                      ? "/assets/img/app-icons/cl.png"
                      : fanStatus == 5
                        ? "/assets/img/app-icons/By.png"
                        : "/assets/img/app-icons/p9.png"
                }
                alt=""
              />
            </div>
            <div className="temp">
              <img src="/assets/img/app-icons/lQ1.png" alt="" />
              <span className="humidity-val">
                {humidity ? humidity + "%" : "-"}
              </span>
              <span className="temperature" dir="ltr">
                {channelTemp && channelTemp !== -64 && channelTemp !== 255
                  ? channelTemp + "°C"
                  : "-"}
              </span>
            </div>
          </div>
          <div className="text-end mt-2">
            <span dir="ltr">
              {outTemp !== null && outTemp !== -64 && outTemp !== 255
                ? outTemp + "°C"
                : "-"}
            </span>
          </div>
        </div>
      );
    });
  };

  return (
    <div
      className="card h-100"
      style={{ backgroundColor: "#fff0", boxShadow: "none" }}
    >
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom mb-3 p-0 pt-2"
        style={{ zIndex: "1" }}
      >
        <h5 className={editEquipmentName ? "d-none" : ""}>
          {equipments.find((eq) => eq.id == eq_id)?.equipment?.name ?? ""}
        </h5>
        <div
          className={editEquipmentName ? "mt-2 d-block" : "d-none"}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <div>
            <input
              id="smallInput"
              className="form-control form-control-sm text-center"
              name="room_name"
              type="text"
              placeholder="نام تجهیز را وارد کنید"
              value={editedEquipmentName}
              onChange={(e) => setEditedEquipmentName(e.target.value)}
            />
          </div>
          <div className="mt-1">
            <button
              type="button"
              className="btn btn-xs btn-success-app submit-add-room me-2"
              onClick={() =>
                handleChangeEquipmentName(
                  equipments.find((eq) => eq.id == eq_id)?.id,
                )
              }
            >
              ثبت
            </button>
            <button
              type="button"
              className="btn btn-xs btn-success-app"
              onClick={(e) => setEditEquipmentName(false)}
            >
              انصراف
            </button>
          </div>
        </div>
        <div>
          {authUser.is_admin ? (
            <>
              <button
                type="button"
                className="btn btn-success-app btn-icon me-2"
                style={{ borderColor: "rgb(0, 165, 148)" }}
                onClick={() => handleRemoveEquipment(selectedEquipment.id)}
              >
                <i className="bx bx-trash"></i>
              </button>
              <div className="btn-group">
                <button
                  type="button"
                  className="btn btn-success-app btn-icon dropdown-toggle hide-arrow"
                  style={{ borderColor: "rgb(0, 165, 148)" }}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bx bx-dots-vertical-rounded"></i>
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <Link
                      className="dropdown-item"
                      onClick={(e) => {
                        e.preventDefault();
                        handleEquipmentsListModal(true);
                      }}
                    >
                      افزدون تجهیز
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to={
                        "/room/select-device/" +
                        room_id +
                        "/" +
                        eq_id +
                        "/" +
                        eq_type
                      }
                    >
                      افزدون کانال به تجهیز
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      onClick={(e) => {
                        handleChangeEquipmentName(
                          equipments.find((eq) => eq.id == eq_id)?.id,
                        );
                      }}
                    >
                      تغییر نام تجهیز
                    </Link>
                  </li>
                </ul>
              </div>
            </>
          ) : null}

          {/* <BackButton url={"/room/" + room_id} /> */}
        </div>
      </div>
      <div
        className="card-body scrollbar mt-sm-2"
        style={{ paddingBottom: "10rem" }}
      >
        {/* <SimpleBar style={{ maxHeight: "100%", padding: "1.5rem" }}> */}
        {renderButtons()}
        {/* </SimpleBar> */}
      </div>
    </div>
  );
};

export default React.memo(FanCoil);
